import { AlphaLIcon } from './AlphaLIcon';

/**
 * author: GreenTurtwig
 * id C4CFE00B-0978-482B-8E9E-F1DD4B21B45B
 * name alpha-l
 * version: 2.8.94
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/alpha-l.svg
 * tags
 * - Alpha / Numeric 
 */
export const LetterLIcon = AlphaLIcon;
export default LetterLIcon